export default __webpack_public_path__ + "static/media/author-img.9d7b09d4.jpg";